var map = {
	"./apps.js": 99177,
	"./auth.js": 57375,
	"./backup.js": 82443,
	"./compliance.js": 44638,
	"./explorer.js": 98918,
	"./fleet.js": 34065,
	"./gatekeeper.js": 97932,
	"./istio.js": 64481,
	"./logging.js": 82072,
	"./longhorn.js": 96070,
	"./manager.js": 19314,
	"./monitoring.js": 87003,
	"./navlinks.js": 95299,
	"./neuvector.js": 29514,
	"./settings.js": 77780,
	"./uiplugins.js": 30043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 14980;